import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UiService} from '../shared/state/ui.service';
import {finalize} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpLoaderInterceptor implements HttpInterceptor {

  constructor(public ui: UiService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.ui.httpLoading(true);
    return next.handle(req).pipe(
      finalize(() => this.ui.httpLoading(false))
    );
  }
}
